// extracted by mini-css-extract-plugin
export var blackTextContact = "index-module--blackTextContact--516e8";
export var orangeTextEntry = "index-module--orangeTextEntry--96065";
export var text = "index-module--text--69ad1";
export var whiteTextEntry = "index-module--whiteTextEntry--27917";